import { DOMCarouselItem } from "../../umadash.js/view/DOMCarousel";
import { SmoothScroll } from "../../umadash.js/util/SmoothScroll";

export class GameCarouselItem extends DOMCarouselItem {

    constructor() {
        super();
    }

    public willAppear(): void {
        const $anchor: JQuery = this.$elm.find('.gameItem__anchor');
        SmoothScroll.attach($anchor);
    }

    public destoroy(): void {
        if (this.$elm) {
            this.$elm.off();
            this.$elm.remove();
            this.$elm = null;
        }
    }
}